import { createContext, useContext } from "react";

export type PageTitleOverrideContextValue = {
  override: string | null;
  setOverride: (title: string | null) => void;
};

export const PageTitleOverrideContext =
  createContext<PageTitleOverrideContextValue | null>(null);

export function usePageTitleOverride() {
  const context = useContext(PageTitleOverrideContext);
  if (!context) {
    throw new Error("usePageTitleOverride must be used within PageTitleOverrideProvider");
  }
  return context;
}

export function usePageTitleOverrideOptional() {
  return useContext(PageTitleOverrideContext);
}
